export default {
  searchresults: "搜索结果",
  boxtitle: "你输入了以下搜索字串",
  fuzzy: '近似搜索', 
  fuzzy_desc: '近似搜寻会回报有拼写错误或字眼相近的结果。注意本功能未涵盖中文搜寻词。',
  fuzzy_on: '使用中',
  fuzzy_off: '已关闭',
  suggestion: '相关搜索词',
  suggestion_desc: '下列为经常并列使用的关键字。点击以增加至你的搜索中。注意本功能未涵盖中文搜寻词。',
  changefilter: '更改搜索范围',
  legis_rec: '你是否在寻找 ',
  status: "状态",
  toadv: "使用进阶搜寻以获得更精确的结果",
  max_reached: "我们只提供了最相关的{0}项结果",
  doc: '文件类别',
  advs: {
    advanced: '进阶搜索',
    advancedshort: '进阶搜索',
    citation: '引述案例编号',
    neutral: '引述案例通用编号',
    legisname: "法例名称",
    parties: "诉讼各方",
    coram: "审理法官",
    representation: "律师代表",
    charge: "控罪",
    allwords: "包含所有字词",
    anywords: "包含任何字词",
    phrase: "包含完整字句",
    help: "查询帮助",
    specfield: "输入指定类别关键字",
    allfield: "输入任何关键字",
    date: "筛选文档日期",
    dbs: "筛选资料库类别",
    selecteddbs: "选择个别资料库",
    selected: "已选",    
  }
}